import { IMortgageInfo } from "../../interfaces";
import PossibilitiesEstimateBase from "./base/posibilitiesEstimate";
import PossibilitiesEstimateRansom from "./ransom/posibilitiesEstimateRansom";

export type TPossibilitiesEstimate = "default" | "ransom" | "forRealtor";

interface IPossibilitiesEstimateProps {
  mode: TPossibilitiesEstimate;
  averageMarketPrice: string;
  mortgageInfo: IMortgageInfo;
  isSecondary: boolean;
}

const PossibilitiesEstimate = ({
  mode = "default",
  averageMarketPrice,
  mortgageInfo,
  isSecondary,
}: IPossibilitiesEstimateProps) => {
  if (mode === "forRealtor") {
    return <></>;
  }

  if (mode === "ransom") {
    return <PossibilitiesEstimateRansom isSecondary={isSecondary} />;
  }

  return (
    <PossibilitiesEstimateBase
      averageMarketPrice={averageMarketPrice}
      mortgageInfo={mortgageInfo}
      isSecondary={isSecondary}
    />
  );
};

export default PossibilitiesEstimate;
